/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Color de fondo',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Todo',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Ancho completo',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Anchura del contenido',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Estrecho',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Estrecho',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Ancho',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Ancho',
  'company-hub.section-extension.config-panel.preamble':
    'Organiza los elementos en secciones personalizables. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label':
    'Obtén más información sobre el diseño de tu centro.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Organiza los elementos relacionados en secciones con fondos y estilos personalizables.',
  'company-hub.section-extension.config-panel.title': 'Sección',
  'company-hub.section-extension.error-loading-content': 'Error al cargar el contenido',
  'company-hub.section-extension.manifest.content.header': 'Asigna un título a tu sección',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Marcador de posición',
  'company-hub.section-extension.manifest.content.sub-header':
    'Organiza los elementos en secciones con fondos personalizables.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Sección',
  'company-hub.section-extension.manifest.extension-title': 'Sección [Nueva]',
  'company-hub.section-extension.manifest.macro-description': 'Agrupa elementos con un fondo',
};
